import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getAuthUserAction } from "../Store/Actions/AuthActions";
import LoaderScreen from "../Pages/LoaderScreen";

const GuestRouter = ({ component: Component }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const loginCheck = () => {
    getAuthUserAction(dispatch)
      .then((res) => {
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loginCheck();
  }, []);

  // if (!loading && isAuthenticated && user.userType === "admin") {
  //   return <Navigate to="/admin" />;
  // } else if (!loading && isAuthenticated && user.userType === "user") {
  //   return <Navigate to="/user" />;
  // } else if (!loading && !isAuthenticated) {

  if (!loading) {
    return <Component />;
  } else {
    return <LoaderScreen />;
  }
};

export default GuestRouter;
